import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class ReleaseRentWithoutInvoiceError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ReleaseRentWithoutInvoiceError', ...args);
    }
}
export default ReleaseRentWithoutInvoiceError;
